var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('organism-edit-service-data',{attrs:{"originServiceDetail":_vm.originServiceDetail},on:{"updateNewService":_vm.onSendRequestToUpdateServiceDetail}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }